import * as yup from 'yup'
import { locales } from './locale'

export function integer() {
  return new IntegerSchema()
}

export class IntegerSchema extends yup.NumberSchema {
  constructor() {
    super()

    // HACK: schema.type is supposed to be read-only, but who cares, right ?
    //@ts-ignore
    this.type = 'integer'

    this.withMutation((schema) => {
      this.transform((value, originalValue) => (/\s/.test(originalValue) ? NaN : value))

      schema.typeError(() => locales.integer.type())
      return schema
    })
  }
}
